<div *ngIf="!isCiamLinkingInProgress && !isCiamClicked && !isProdEnvironment; else SpinnerLoads">
    <app-login></app-login>
</div>
<ng-template #SpinnerLoads>
    <app-spinner-component></app-spinner-component>
</ng-template>